// Prototype personas from CSS Profile Decision-Tree Tester - Prototype.html, translated to
// the field names used by the active v1-26 ruleset (q_student_dep, q_par_marital_status, etc.).

const TAX_FORM = { '1': '1040', '5': 'foreign', '6': 'foreign', '7': 'foreign', '0': 'none' };
const MARITAL = { MJ: 'married', MFS: 'separated', S: 'single', HoH: 'single', QSS: 'widowed' };

function translate(proto) {
  const out = {};
  out.q_student_dep = proto.ApplicationType === 'D' ? 'yes' : 'no';
  out.VarParentDataRequired =
    proto.ForceParentData === 'Y' ? 'yes' : (proto.ApplicationType === 'D' ? 'yes' : 'no');
  out.q_par_marital_status = MARITAL[proto.FilingStatus] ?? 'single';
  out.q_par_tax_form = TAX_FORM[proto.TaxForm] ?? 'none';
  out.q_household_size = Number(proto.HHCount || 1);
  out.q_dep_count = Math.max(0, Number(proto.HHCount || 1) - 2);
  out.q_college_count = 1;
  const isLite = proto.TaxForm === '0' || proto.HHBLite === 'Y';
  out.q_par_agi = isLite ? 28000 : 95000;
  out.q_par_income = isLite ? 28000 : 95000;
  out.q_par_assets = isLite ? 2000 : 40000;
  out.q_student_income = 3000;
  out.q_student_assets = 1500;
  return out;
}

const RAW = [
  { name: 'Dep · HHA · 1040 Married-Joint',
    fields: { ApplicationType: 'D', HHB: 'N', HHBLite: 'N', TaxForm: '1', FilingStatus: 'MJ', HHCount: '4' } },
  { name: 'Dep · HHA + HHB · 1040 MFS',
    fields: { ApplicationType: 'D', HHB: 'Y', HHBLite: 'N', TaxForm: '1', FilingStatus: 'MFS', HHCount: '3' } },
  { name: 'Dep · HHA · Lite (low-income)',
    fields: { ApplicationType: 'D', HHB: 'N', HHBLite: 'N', TaxForm: '0', FilingStatus: 'HoH', HHCount: '3' } },
  { name: 'Dep · HHA + HHB Lite (new 26/27)',
    fields: { ApplicationType: 'D', HHB: 'Y', HHBLite: 'Y', TaxForm: '1', FilingStatus: 'MJ', HHCount: '4' } },
  { name: 'Independent · Married w/ spouse',
    fields: { ApplicationType: 'I', HHB: 'N', HHBLite: 'N', TaxForm: '1', FilingStatus: 'MJ', HHCount: '2' } },
  { name: 'Dep · International · Foreign tax',
    fields: { ApplicationType: 'D', HHB: 'N', HHBLite: 'N', TaxForm: '7', FilingStatus: 'MJ', HHCount: '5' } },
  { name: 'Dep · HHA · Canadian filer',
    fields: { ApplicationType: 'D', HHB: 'N', HHBLite: 'N', TaxForm: '6', FilingStatus: 'MJ', HHCount: '4' } },
  { name: 'Dep · HHA · US Non-Filer',
    fields: { ApplicationType: 'D', HHB: 'N', HHBLite: 'N', TaxForm: '0', FilingStatus: 'HoH', HHCount: '3' } },
  { name: 'Independent · Parent data required',
    fields: { ApplicationType: 'I', ForceParentData: 'Y', HHB: 'N', HHBLite: 'N', TaxForm: '1', FilingStatus: 'MJ', HHCount: '4' } }
];

export const PROTOTYPE_PERSONAS = RAW.map(({ name, fields }) => ({
  name,
  visibility: 'org',
  profile: translate(fields)
}));
